import { Descriptions, Table, Tag } from 'antd';
import React from 'react';
import { translations } from '../../../../config/translations';
import { formatDate } from '../../../../helpers/DateHelper';
import { getTableLocale } from '../../../../helpers/TableHelper';
import { ToolTransferDetailVm, ToolTransferItemVm, TransferStatusEnum } from '../../../../utils/api';
import TransferStatusTag from '../../transfer-status-tag/TransferStatusTag';

interface Props {
    transfer: ToolTransferDetailVm;
}

const TransferDetails: React.FC<Props> = ({ transfer }: Props) => {
    const isReceived = transfer.status === TransferStatusEnum.Received;

    const columns = [
        {
            title: translations.transfers.tools,
            dataIndex: 'toolName',
        },
        {
            title: translations.transfers.status,
            key: 'received',
            render: (_: unknown, item: ToolTransferItemVm): React.ReactElement => {
                if (item.received == null) {
                    return <Tag>{translations.transfers.inTransfer}</Tag>;
                }

                return item.received ? (
                    <Tag color="green">{translations.transfers.arrived}</Tag>
                ) : (
                    <Tag color="red">{translations.transfers.notArrived}</Tag>
                );
            },
        },
        {
            title: translations.transfers.lostReason,
            dataIndex: 'lostReason',
        },
    ];

    return (
        <>
            <Descriptions bordered size="small" column={2}>
                <Descriptions.Item label={translations.transfers.fromWarehouse}>
                    {transfer.fromName}
                </Descriptions.Item>
                <Descriptions.Item label={translations.transfers.toWarehouse}>
                    {transfer.toName}
                </Descriptions.Item>
                <Descriptions.Item label={translations.transfers.status}>
                    <TransferStatusTag status={transfer.status} />
                </Descriptions.Item>
                <Descriptions.Item label={translations.transfers.note}>
                    {transfer.note}
                </Descriptions.Item>
                <Descriptions.Item label={translations.transfers.createdBy}>
                    {transfer.createdByName}
                </Descriptions.Item>
                <Descriptions.Item label={translations.transfers.createdDate}>
                    {formatDate(transfer.createdDate)}
                </Descriptions.Item>
                <Descriptions.Item label={translations.transfers.shippedBy}>
                    {transfer.shippedByName}
                </Descriptions.Item>
                <Descriptions.Item label={translations.transfers.shippedDate}>
                    {transfer.shippedDate ? formatDate(transfer.shippedDate) : ''}
                </Descriptions.Item>
                <Descriptions.Item label={translations.transfers.receivedBy}>
                    {transfer.receivedByName}
                </Descriptions.Item>
                <Descriptions.Item label={translations.transfers.receivedDate}>
                    {transfer.receivedDate ? formatDate(transfer.receivedDate) : ''}
                </Descriptions.Item>
                {transfer.driverLegacy && (
                    <Descriptions.Item label={translations.transfers.driver}>
                        {transfer.driverLegacy}
                    </Descriptions.Item>
                )}
            </Descriptions>

            <Table
                style={{ marginTop: 24 }}
                locale={getTableLocale()}
                columns={isReceived ? columns : columns.slice(0, 2)}
                dataSource={transfer.items}
                rowKey={(item: ToolTransferItemVm): string => item.id.toString()}
                pagination={false}
                bordered
                size="small"
            />
        </>
    );
};

export default TransferDetails;
